// libraries
import React, { useMemo, useState } from 'react';
import { Provider } from 'react-redux';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
// Config
import { store } from './config/store';
// views
import App from './App';
import NavigateSetter from './config/history';
// Hooks
import useTenant from './hooks/useTenant';
// Helpers
import { setKeyCloakTokens } from './services/mainHelpers';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const KEYCLOAK_INIT_OPTIONS = {
  responseMode: 'query',
  onLoad: 'check-sso',
  silentCheckSsoRedirectUri: `${window.location.origin}/index.html`,
};

export const MainApp = () => {
  const { keycloak, tenantError } = useTenant();

  // Ensure QueryClient isn't dumped/recreated on every component render
  const [queryClient] = useState(() => new QueryClient());

  const getEvent = (eventType) => {
    if (keycloak.authenticated && eventType === 'onReady') {
      setKeyCloakTokens(keycloak);
    }
  };

  // Define Data Router
  const router = useMemo(() => createHashRouter([
    {
      path: "/*",
      element: (
        <>
          <NavigateSetter />
          <App />
        </>
      ),
    }
  ]), []);

  return (
    tenantError ? (
      <div>{tenantError.message}</div>
    ) : (
      keycloak && (
      <ReactKeycloakProvider
        authClient={keycloak}
        onEvent={getEvent}
        initOptions={KEYCLOAK_INIT_OPTIONS}
      >
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </Provider>
      </ReactKeycloakProvider>)
    )
  );
};

export default MainApp;